import { Twitter } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h2 className="text-xl font-bold">
              stickersby<span className="text-accent">.ai</span>
            </h2>
            <p className="text-gray-600 text-sm mt-1">Idea to product in 4 steps!</p>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-center">
            <a
              href="https://x.com/AiStickersby"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-secondary flex items-center gap-2"
            >
              <Twitter size={18} />
              <span>Follow us</span>
            </a>

            <div className="flex gap-4">
              <Link to="/terms" className="text-gray-600 hover:text-secondary text-sm">
                Terms
              </Link>
              <Link to="/privacy" className="text-gray-600 hover:text-secondary text-sm">
                Privacy
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t mt-4 pt-4 text-center md:text-left">
          <p className="text-gray-600 text-sm">
            © {currentYear} stickersby.ai. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
